import React, { useEffect, useState } from 'react'

import Navbar from './Navbar'
import Sidebar from './Sidebar'
import { useLocation } from 'react-router-dom'
import InternetConnectivity from '../../shared/InternetConnectivity'

const AuthenticatedLayout = ({ children }) => {
  const [activeSection, setActiveSection] = useState('Dashboard')
  const location = useLocation()

  useEffect(() => {
    const pathName = location.pathname.split('/').filter(Boolean).pop() || ''
    setActiveSection(pathName.replace(/-/g, ' '))
  }, [location.pathname])

  return (
    <div className='flex items-center !h-screen !justify-center overflow-hidden'>
      <InternetConnectivity />
      <div className='hidden md:block'>
        <Sidebar />
      </div>
      <div className='w-full flex-col h-full flex !overflow-hidden'>
        <Navbar activeSection={activeSection} />
        <div className='min-h-[calc(100vh-50px)] h-full w-full overflow-hidden bg-white rounded-md'>
          {children}
        </div>
      </div>
    </div>
  )
}

export default AuthenticatedLayout
